import { render, staticRenderFns } from "./SystemPermissionGroupCreateButton.vue?vue&type=template&id=15a42885&scoped=true"
import script from "./SystemPermissionGroupCreateButton.vue?vue&type=script&lang=js"
export * from "./SystemPermissionGroupCreateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a42885",
  null
  
)

export default component.exports